import Vue from 'vue'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

const createConnection = () => {
  const token = localStorage.getItem('token')
  if (!token) {
    return null
  }

  return new HubConnectionBuilder()
    .withUrl(`${window.config.websocketBaseUrl}?access_token=${token}`)
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning) // Only warnings and errors
    .build()
}

const signalrConnection = createConnection()

// Start once on load if token exists
if (signalrConnection && localStorage.getItem('token')) {
  signalrConnection.start()
    .then(() => console.log('SignalR connected'))
    .catch(err => console.error('SignalR connection failed:', err.message))
}

if (signalrConnection) {
  Vue.prototype.$socket = signalrConnection
}

export default signalrConnection
